import React from 'react';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CustomAccordion from '../Accordian/accordian';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import { alert, OperatorAlert } from '../../models/FacilityAlert';
import { useGetFacilityOperatorAlertsQuery, useGetOperatorAlertsQuery } from '../../api/endpoints/apiConfig';
import { facility } from '../../models/DashboardInformation';
import { Allalertsdata } from '../../models/AllOperatoralerts';;
interface FacilityInformationProps {
    data: facility | null;
}
const Alerts: React.FC<FacilityInformationProps> = ({ data }) => {
    // Call hooks unconditionally
    const operatorId = sessionStorage.getItem('operatorId');
    // const [allAlerts, setAllAlerts] = useState<alert[] | null>(null);
    const { data: FacilityOperatorAlerts } = useGetFacilityOperatorAlertsQuery(operatorId ? parseInt(operatorId) : 0);
    const { data: alertsData } = useGetOperatorAlertsQuery();
    const dateOptions: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
    };
    if (!data) {
        return (
            <CustomAccordion defaultExpanded>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1-content" id="panel1-header">
                    <Typography variant="h3" color="text.secondary">
                        Alerts
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    No data available
                </AccordionDetails>
            </CustomAccordion>
        );
    }
    // if the alert not available in FacilitybyOperatorIdAlerts then it will set the All alert 
    const alloperatorAlerts = alertsData?.operators?.flatMap((operator: Allalertsdata) => operator.alerts) || [];
    const OperatorAlert = FacilityOperatorAlerts?.operator?.alerts || [];
    const Alertsfacilityfetch = data?.alerts || []; // Local alerts from facility data

    // Combine alerts from both sources and ensure both are arrays

    const combinedAlerts: (alert | OperatorAlert)[] = [...Alertsfacilityfetch, ...OperatorAlert];

    return (
        <CustomAccordion defaultExpanded>
            <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1-content" id="panel1-header">
                <Typography variant="h3" color="text.secondary">
                    Alerts
                </Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Stack sx={{ width: '100%' }} spacing={2}>
                    {combinedAlerts.length > 0 ? (
                        combinedAlerts.map((alert, index) => (
                            <Alert
                                key={index}
                                icon={
                                    alert.alert_color === 'blue' ? (
                                        <InfoOutlinedIcon sx={{ color: '#9A4D05' }} />
                                    ) : (
                                        <WarningAmberOutlinedIcon sx={{ color: '#A90606' }} />
                                    )
                                }
                                severity={alert.alert_color === 'blue' ? 'warning' : 'error'}
                                sx={{ alignItems: 'center' }}
                            >
                                <Typography color="text.secondary" variant="body2">
                                    {alert.alert_text}
                                </Typography>
                                <Typography variant="caption" fontWeight={500} color="#626262">
                                    Created {new Date(alert.created_at).toLocaleString('en-US', dateOptions)}
                                </Typography>
                            </Alert>
                        ))
                    ) : alloperatorAlerts.length > 0 ? (
                        alloperatorAlerts.map((alert, index) => (
                            <Alert
                                key={index}
                                icon={
                                    alert.alert_color === 'blue' ? (
                                        <InfoOutlinedIcon sx={{ color: '#9A4D05' }} />
                                    ) : (
                                        <WarningAmberOutlinedIcon sx={{ color: '#A90606' }} />
                                    )
                                }
                                severity={alert.alert_color === 'blue' ? 'warning' : 'error'}
                                sx={{ alignItems: 'center' }}
                            >
                                <Typography color="text.secondary" variant="body2">
                                    {alert.alert_text}
                                </Typography>
                                <Typography variant="caption" fontWeight={500} color="#626262">
                                    Created {new Date(alert.created_at).toLocaleString('en-US', dateOptions)}
                                </Typography>
                            </Alert>
                        ))
                    ) : (
                        <Typography variant="body2" color="text.secondary">
                            No alerts available.
                        </Typography>
                    )}
                </Stack>
            </AccordionDetails>
        </CustomAccordion>
    );

}; export default Alerts;